const _p = new URLSearchParams(window.location.search);

/** URL parameters injected by the Zitadel launcher. Read once at module init. */
export const urlParams = {
  /** JWT bearer token from `?token=<jwt>` (Zitadel mode). */
  token: _p.get('token') ?? '',
  /** API stage identifier from `?stageId=<id>`. */
  stageId: _p.get('stageId') ?? '',
  /** Game-session ID from `?gameSessionId=<id>`. */
  gameSessionId: _p.get('gameSessionId') ?? '',
  /** HMAC key from `?key=<key>`. */
  key: _p.get('key') ?? '',
  /** Timer feature-flag override from `?timer=true|false`; empty string means "use config default". */
  timer: _p.get('timer') ?? '',
  /** Time-limit override in seconds from `?timeLimit=<seconds>`; empty string means "use config default". */
  timeLimit: _p.get('timeLimit') ?? '',
} as const;
